module.exports = __webpack_public_path__ + "img/MOC.c36c195f.svg";